import {Controller} from '@hotwired/stimulus';

/**
 * Fait naviguer, dès sa connexion, la page qui a ouvert la fenêtre fancybox vers l'URL en value ; hors d'une
 * iframe, la page qui le porte.
 *
 *   <div {{ stimulus_controller('parent-redirect', {url: path('route.de.destination')}) }}>…</div>
 */
export default class extends Controller {
  static values = {url: String};

  connect() {
    window.parent.location.href = this.urlValue;
  }
}
